<template>
  <div class="list-div">
    <ul class="data-list">
      <li
        v-for="(item, index) in list.length > 0 ? list : dataList"
        :key="index"
        @click="handleClick(item, index)"
      >
        <slot name="list-item">
          <div
            v-if="urlIf == true && item.redirectUrl !== ''"
            class="title text-ellipsis"
            target="_blank"
          >
            <a target="_blank" :href="item.redirectUrl">{{ item.title }}</a>
          </div>
          <router-link
            v-else-if="!$props.itemNoJump"
            :to="`${itemRouterLinkTo}?id=${
              item.contentId ? item.contentId : item.id
            }&documentTitle=${item.title}&catalogAlisa=${$props.catalogAlisa}`"
            class="title text-ellipsis"
          >
            {{ item.title }}
          </router-link>
          <div v-else class="title text-ellipsis">{{ item.title }}</div>
          <span class="time">{{ item.publishDate }}</span>
        </slot>
      </li>
    </ul>
    <UiEmpty v-if="!loading && !dataList.length" />
    <UiPagination
      v-if="totalPages > 1 && show"
      v-model="listQuery.pageNum"
      :totalPages="totalPages"
      :pageSize="listQuery.pageSize"
      position="right"
      @change="getList"
    />
  </div>
</template>

<script>
import { cmsCatalogContentList, xwzxList } from "@/api/index";
import dayjs from "dayjs";

export default {
  name: "Index",
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    catalogAlisa: {
      type: String,
      required: true,
    },
    itemRouterLinkTo: {
      type: String,
      default: "",
    },
    // 是否不跳转
    itemNoJump: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
    urlIf: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadFirst: true,
      loading: true,
      dataList: [],
      listQuery: {
        pageNum: 1,
        pageSize: this.$props.Number,
        catalogAlisa: this.$props.catalogAlisa,
      },
      totalPages: 0,
      EnglishIf: false,
    };
  },
  mounted() {
    this.getList();
    if (localStorage.getItem("EnglishIf")) {
      this.EnglishIf =
        localStorage.getItem("EnglishIf") == "true" ? true : false;
    }
    const that = this;
    window.addEventListener("setItemEvent", function (e) {
      if (e.key === "EnglishIf") {
        that.EnglishIf = JSON.parse(e.newValue);
      }
    });
  },
  methods: {
    getList() {
      this.loading = true;
      if (this.listQuery.catalogAlisa == "xwzx") {
        xwzxList().then((res) => {
          this.dataList = res.data.res.cmsContentList.map((el) => {
            return {
              ...el,
              publishDate: dayjs(Number(el.publishDate)).format("YYYY-MM-DD"),
            };
          });
        });
      } else {
        cmsCatalogContentList(this.listQuery)
          .then((res) => {
            this.dataList = res.data.contentList.map((el) => {
              return {
                ...el,
                publishDate: dayjs(Number(el.publishDate)).format("YYYY-MM-DD"),
              };
            });
            this.totalPages = res.data.total;
          })
          .finally(() => {
            this.loading = false;
            this.loadFirst = false;
          });
      }
    },
    handleClick(item, index) {
      this.$emit("item-click", item, index);
    },
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 768px) {
  .data-list {
    font-size: 1rem !important;
  }
  .data-list > li > .title {
    font-size: 1rem !important;
  }
}
.breadcrumb-box {
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: #5b2400 solid 1.5px;
}
.data-list {
  font-size: 21px;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: #e5e5e5 solid 1px;
    color: #5b2400;

    &:hover {
      color: #5b2400;
      .title {
        text-decoration: underline;
      }
    }

    &::before {
      content: "";
      margin-right: 10px;
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #5b2400;
    }

    .title {
      flex: 1;
      margin-right: 10px;
      cursor: pointer;
    }
    .time {
      font-size: 14px;
      margin-left: auto;
      color: #747474;
    }
  }
}
</style>
